import React from 'react';
import { Tooltip, makeStyles } from '@material-ui/core';
import { object, func, bool } from 'prop-types';
import styles from './styles';
import { getI18nFormattedMessage } from '../../../../../utils/intl';
import clsx from 'clsx';


export default function EntityCard({ entity, entityClickTab, setActiveTab, disabled }) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const entityTitles = {
    APIs: 'apis',
    APIGroups: 'apigroups',
    Keys: 'keys',
    Certificates: 'certificates',
    ExpiryToCertificates: 'certexpirydays',
  };
  const cardsWithToolTip = [
    'ExpiryToCertificates',
  ];
  const handleCardClick = (event, entityName) => {
    if(!disabled) {
      setActiveTab(entityClickTab[entityName]);
    }
  };

  const handleEnterKey = (event, entityName) => {
    const code = event.keyCode || event.which;
    if (code === 13) {
      handleCardClick(event, entityName);
    }
  };
  const getClassName = () => {
    if(entity.count < entity.errorCount) {
      return classes.errorCount;
    }
    if(entity.count < entity.warningCount) {
      return classes.warningCount;
    }
    return classes.normalCount;
  };

  const renderTile = () => (
    <div
      tabIndex="0"
      className={disabled ? classes.disabledCard : classes.card}
      onClick={e => handleCardClick(e, entity.entity)}
      onKeyDown={e => handleEnterKey(e, entity.entity, true)}
    >  <div className={disabled ? classes.disabledEntityTitle : classes.entityTitle}>
          {getI18nFormattedMessage(`label.application.details.overview.scrollbar.${entityTitles[entity.entity]}.title`)}
        </div>
        <div className={clsx(classes.entityCount, getClassName())}>
          {entity.format || entity.count}
        </div>
    </div>
  );
  return (
    <>
      {cardsWithToolTip.includes(entity.entity) ?
        <Tooltip title={getI18nFormattedMessage(`label.application.details.overview.scrollbar.${entityTitles[entity.entity]}.tooltip`)}>
        {renderTile()}
        </Tooltip> :
        renderTile()
      }
    </>
  );
}

EntityCard.propTypes = {
  entity: object,
  entityClickTab: object,
  setActiveTab: func,
  disabled: bool,
};
